import script from "./m-card.vue?vue&type=script&setup=true&lang=js"
export * from "./m-card.vue?vue&type=script&setup=true&lang=js"

import "./m-card.vue?vue&type=style&index=0&id=0ac70de0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac70de0"]])

export default __exports__